import "angular-messages";
import "angular-ui-mask";
import ValidationDirectives from "../../common/directives/ValidationDirectives";
import TaxIdentificationNumberDirective from "../../common/directives/TaxIdentificationNumberDirective";
import BeneficiaryDateDirective from "core-ui/client/src/app/BeneficiaryDateDirective";
import MaskDirective from "core-ui/client/src/app/MaskDirective";
import PrintDirective from "core-ui/client/src/app/PrintDirective";
import BeneficiarySocialSecurityNumberDirective from "core-ui/client/src/app/BeneficiarySocialSecurityNumberDirective";
import ZIPCodeDirective from "core-ui/client/src/app/ZIPCodeDirective";
import BeneficiaryPhoneNumberDirective from "core-ui/client/src/app/BeneficiaryPhoneNumberDirective";
import UnsafeFilter from "core-ui/client/src/app/UnsafeFilter";
import SocialSecurityNumberFilter from "core-ui/client/src/app/SocialSecurityNumberFilter";
import httpExceptionInterceptorProvider from "core-ui/client/src/app/HttpExceptionInterceptorProvider";
import GroupModule from "core-ui/client/src/app/GroupModule";
import FevaDisclosureDirective from "core-ui/client/src/app/FevaDisclosureDirective";
import AllocationFactory from "../../services/AllocationFactory";
import DataService from "../../services/DataService";
import beneficiaryService from "../../services/BeneficiaryService";
import BeneficiaryTypeService from "../../services/BeneficiaryTypeService";
import FormService from "../../services/FormService";
import participantService from "../../services/ParticipantService";
import beneficiaryAgreementController from "./view/list/beneficiaryAgreement/beneficiaryAgreementController";
import BeneficiarySaveChangesController from "./view/saveChanges/saveChangesController";
import BeneInvalidRelationshipDirective from "./view/form/BeneInvalidRelationshipDirective";
import ListBeneficiariesDirective from "./view/list/ListBeneficiariesDirective";
import BeneficiaryController from "./BeneficiaryController";
import BeneficiaryListController from "./view/list/BeneficiaryListController";
import BeneficiaryFormController from "./view/form/BeneficiaryFormController";
import ConfirmationController from "./view/confirmation/ConfirmationController";

var BeneficiaryModule = angular.module("BeneficiaryModule", [
    "ngMessages",
    "ngResource",
    "ui.router",
    "ui.mask",
    // Directive Modules
    BeneficiaryDateDirective.name,
    BeneficiaryPhoneNumberDirective.name,
    BeneficiarySocialSecurityNumberDirective.name,
    GroupModule.name,
    MaskDirective.name,
    PrintDirective.name,
    SocialSecurityNumberFilter.name,
    TaxIdentificationNumberDirective.name,
    UnsafeFilter.name,
    ValidationDirectives.name,
    ZIPCodeDirective.name,
    httpExceptionInterceptorProvider.name
]);

BeneficiaryModule.factory("allocationFactory", AllocationFactory);
BeneficiaryModule.service("dataService", DataService);
BeneficiaryModule.service("beneficiaryService", beneficiaryService);
BeneficiaryModule.service("beneficiaryTypeService", BeneficiaryTypeService);
BeneficiaryModule.service("formService", FormService);
BeneficiaryModule.service("participantService", participantService);
BeneficiaryModule.controller("beneficiaryAgreementController", beneficiaryAgreementController);
BeneficiaryModule.controller("beneficiarySaveChangesController", BeneficiarySaveChangesController);
BeneficiaryModule.controller("beneficiaryController", BeneficiaryController);
BeneficiaryModule.controller("beneficiaryListController", BeneficiaryListController);
BeneficiaryModule.controller("beneficiaryFormController", BeneficiaryFormController);
BeneficiaryModule.controller("confirmationController", ConfirmationController);
BeneficiaryModule.directive("pwFevaDisclosure", FevaDisclosureDirective);
BeneficiaryModule.directive("beneInvalidRelationshipDirective", BeneInvalidRelationshipDirective);
BeneficiaryModule.directive("listBeneficiaries", ListBeneficiariesDirective);

// If we are coming to bene from an outside page, reset the stored data so we can get it from the database.
BeneficiaryModule.run([
    "$rootScope",
    "beneficiaryService",
    "dataService",
    "participantService",
    "$location",
    function ($rootScope, beneficiaryService, dataService, participantService, $location) {
        $rootScope.$on("profileLinkClicked", function (e, data) {
            var toState = { name: "profile" };
            var toParams = null;
            checkSaveChangesDialog(data, toState, toParams);
        });

        $rootScope.$on("$stateChangeStart", function (e, toState, toParams, fromState) {
            if (toState.name.indexOf("beneficiaries") === -1) {
                checkSaveChangesDialog(e, toState, toParams);
            }
            if (
                toState.name.indexOf("beneficiaries") >= 0 &&
                fromState.name.indexOf("beneficiaries") == -1
            ) {
                beneficiaryService.reset();
                dataService.reset();
                participantService.reset();
                beneficiaryService.resetSaveChangesModal();
            }
        });

        function checkSaveChangesDialog(e, toState, toParams) {
            if (beneficiaryService.getShowSaveDialog()) {
                // set the destination info
                beneficiaryService.setToState(toState);
                beneficiaryService.setToStateParams(toParams);
                // stop the transition
                e.preventDefault();
                // open the modal
                if (!beneficiaryService.getDialogLoading()) {
                    beneficiaryService.setDialogLoading(true);
                    if (toState.name === "profile") {
                        beneficiaryService.setProfileLink(e.currentTarget.href);
                    }
                    if (
                        !window.userIsAuthenticated &&
                        toState.name.indexOf("loginSessionError") >= 0
                    ) {
                        window.location.href = `${window.location.origin}/participant/#/login`;
                    } else {
                        beneficiaryService.openSaveChangesModal();
                    }
                }
            }
        }

        // We need to track where the participant came from when entering a beneficiary-ui view so we can redirect
        // back to it under certain conditions for QJSA.
        $rootScope.$on("$locationChangeSuccess", function () {
            var url = $location.url();

            // Only track the URL if it doesn't match "beneficiaries" or "beneficiary"
            if (url.indexOf("beneficiar") === -1) {
                beneficiaryService.setFromUrl(url);
            }
        });
    }
]);

export default BeneficiaryModule;
